import {
  Banner,
  Button,
  CircularLoader,
  Dropdown,
  Modal,
  Switch,
  Typography,
} from "@plum-xoxo/admin-dsm";
import axios from "axios";
import isEqual from "lodash/isEqual";
import React, { Component } from "react";
import { NotificationManager } from "react-notifications";
import styled from "styled-components";
import Loader from "../../components/Loader";
import KybOtpModal from "../../components/Modals/KybOtpModal";
import {
  MOBILE_NO_ERROR,
  TURNSTILE_SITE_KEY,
  adminRole,
} from "../../constants/AppConstant";
import {
  CustomCard,
  EditInfoInput,
} from "../../modules/Accounts/PlatformPreferences/Component/styled";
import {
  default as ProfileService,
  default as profileService,
} from "../../services/profileService";
import {
  getTaxType,
  makeRequestAuth,
  validatePhoneNo,
} from "../../utils/globals";
import { datas } from "../../constants/Country";

import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { app_path } from "config";
import KYBSubmitInfoModal from "../DiyDashboard/components/KYBSubmitInfoModal";
import AddCompanyAddressForm from "../../components/AddAddressForm/AddCompanyAddressForm";
import debounce from "lodash/debounce";

const CustomChip = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.green.c000};
  border: 1px solid ${(props) => props.theme.palette.green.c100};
  color: ${(props) => props.theme.palette.green.c300};
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
  padding: 4px;
`;
const CustomDropdown = styled(Dropdown).attrs()`
  width: 145px !important;
`;

const websiteReg =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

const StyledDropdown = styled(Dropdown).attrs()`
  .eui-dd-opt-label {
    display: block;
    height: 24px;
  }
`;
const StyledCard = styled.div`
  background: ${(props) => props.theme.palette.light.c100} !important;
`;
const COMPANY_ADDRESS = {
  city_id: "",
  company_address1: "",
  country_id: "",
  state_id: "",
  zip_code: "",
  company_website: "",
  taxId: "",
  re_enter_taxId: "",
  companyName: "",
  linkedIn: "",
};

const COMPANY_ADDRESS_ERROR = {
  city_id: "",
  company_address1: "",
  country_id: "",
  state_id: "",
  zip_code: "",
  company_website: "",
  taxId: "",
  re_enter_taxId: "",
  companyName: "",
  linkedIn: "",
};

class SubmitKybForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ipCurrencyCode: "",
      currencyValue: {},
      currencyCodeList: [],
      showModal: false,
      companyAddress: COMPANY_ADDRESS,
      errorCompanyAddress: COMPANY_ADDRESS_ERROR,
      countryOption: [],
      stateOption: [],
      cityOption: [],
      selectedCountry: "",
      selectedState: "",
      selectedCity: "",
      companyTaxId: "",
      gstModalShow: false,
      taxIdList: [],
      confirmModal: false,
      successModal: false,
      modified: false,
      taxType: "GST",
      showTaxType: false,
      showKycConfirmModal: false,
      errorState: false,
      errorCity: false,
      submit_kyb: false,
      ipCountryCode: "",
      placeHolder: "",
      phoneNumber: "",
      showOtpModal: false,
      invalidOtpMsg: false,
      showResendMsg: false,
      otpValue: "",
      otp_id: "",
      otpAutoFocusTrigger: false,
      showOtpLoading: false,
      employeeName: null,
      phone_codes_ui: [],
      isd_code_object: {},
      isMobileVerified: false,
      errorName: "",
      errorPhone: "",
      errorCountryOfRegistration: "",
      invalidOtpCount: 0,
      voucher_distribute_types: 1,
      is_voucher_listed_in_b2c: 1,
      end_user_payment_methods: 1,
      is_voucher_listed_in_crypto: 1,
      selectError: {
        voucher_distribute_types: "",
        is_voucher_listed_in_b2c: "",
        end_user_payment_methods: "",
        is_voucher_listed_in_crypto: "",
      },
      additionalDetailsLoading: true,
      switchModified: false,
      mobileNotVerified: false,
      otpParams: {},
      showTurnstileCaptcha: false,
      showVerificationTurnstileCaptcha: false,
      showResendTurnstileCaptcha: false,
      fetchAccountDetailsLoader: false,
    };
    this.companyWebsiteInputRef = React.createRef();
  }

  makeCurrencyOptions = () => {
    const currencyCodeList = datas
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map(function (item) {
        return {
          country_name: item.name,
          value: item.name + item.code,
          currencyValue: item.code,
          currency_id: item.currency_id,
          label: (
            <Typography
              component="div"
              className="d-flex m-0 p-0 mb-0 justify-content-start align-items-center"
            >
              <Typography color="dark" shade="c300" className="m-0 p-0">
                {item.emoji}{" "}
              </Typography>
              <Typography color="dark" shade="c300" className="m-0 pl-8 pr-4">
                {item.name}{" "}
              </Typography>
              <Typography color="dark" shade="c300" className="m-0 p-0">
                - {item.code}
              </Typography>
            </Typography>
          ),
          emoji: item.emoji,
        };
      });

    this.setState({
      currencyCodeList: currencyCodeList,
    });
  };

  componentDidMount() {
    this.getGeoCountryCode();
    this.validateTaxtype();
    this.makeCurrencyOptions();
  }

  submitKybDetails = () => {
    // client_website: companyAddress.company_website,
    const { phnNumber = "", phonecode = "" } = this.props;
    this.setState({
      submit_kyb: true,
      loading: true,
      showKycConfirmModal: false,
    });
    let {
      companyAddress,
      errorCompanyAddress,
      employeeName,
      phoneNumber,
      isd_code_object,
      selectedCountryISO,
      voucher_distribute_types,
      is_voucher_listed_in_b2c,
      end_user_payment_methods,
      is_voucher_listed_in_crypto,
      currencyValue,
    } = this.state;
    const query = "diy.mutation.submit_kyb_plum_user_details_v2";
    const variables = {
      client_legal_name: companyAddress.companyName,
      gst: companyAddress.taxId,
      tax_country_code: selectedCountryISO.value,
      currency_code: currencyValue.currencyValue,
      // contact: `${phonecode}-${phnNumber}`,
      address: JSON.stringify([
        {
          address: companyAddress.company_address1,
          country_id: companyAddress.country_id,
          state_id: companyAddress.state_id,
          city_id: parseInt(companyAddress.city_id),
          zip_code: companyAddress.zip_code,
        },
      ]),
      inActiveResubmission:
        "" + (this.props?.kybStatus?.kyb_status == 6 ? 1 : 0),
    };
    if (voucher_distribute_types == 3 && is_voucher_listed_in_b2c !== null) {
      variables.is_voucher_listed_in_b2c = is_voucher_listed_in_b2c;
    }
    if (end_user_payment_methods == 2 && is_voucher_listed_in_crypto !== null) {
      variables.is_voucher_listed_in_crypto = is_voucher_listed_in_crypto;
    }
    const request_data = {
      query,
      tag: "diy",
      variables: variables,
    };

    makeRequestAuth(request_data, (response) => {
      const { data } = response;
      const { submitKybDetailV2 } = data;

      if (submitKybDetailV2 && submitKybDetailV2.success != "0") {
        this.updateKybStatus();
        // this.fetchActivationSteps();
        this.props.getClientId();
        this.props?.history.goBack();
        this.setState({
          showKycConfirmModal: false,
          submit_kyb: true,
          loading: false,
        });
      } else {
        this.setState({
          showKycConfirmModal: false,
          submit_kyb: false,
          loading: false,
        });
        this.props.getClientId();

        if (
          submitKybDetailV2.message[0] === "Contact number is not verified!"
        ) {
          this.setState({ mobileNotVerified: true });
          return false;
        }
        this.props?.history.goBack();

        NotificationManager.error(submitKybDetailV2.message);
      }
    });
  };

  getCompanySearchList = (value, callback, signal = false) => {
    this.setState({ companyListLoading: true });
    const query = "diy.mutation.companySearch";
    const request_data = {
      query,
      tag: "diy",
      variables: { client_legal_name: value },
    };
    makeRequestAuth(
      request_data,
      function (response) {
        if (signal?.aborted) {
          return;
        }
        let companyListOptions = [];
        if (response?.data?.companySearch?.success == 1) {
          companyListOptions = response.data.companySearch.data.map((item) => {
            return {
              value: item?.name,
              label: `${item.name}, ${item.gstin}`,
              placeHolder: item.name,
              companyNumber: item.gstin,
            };
          });
        } else {
          this.setState({ dasboard_load: false });
        }
        companyListOptions.push({
          value: value,
          label: `Create new "${value}"`,
        });
        callback(companyListOptions);

        this.setState({
          companyList: companyListOptions,
        });
      }.bind(this),
      "",
      "",
      signal
    );
  };

  fetchCompanyByTax = (value) => {
    this.setState({ fetchAccountDetailsLoader: true });
    let registration_number = value?.companyNumber;
    if (!registration_number) {
      this.setState({ fetchAccountDetailsLoader: false });
      return;
    }
    this.setState({ companyListLoading: true });
    const query = "diy.mutation.fetchCompanyByTax";
    const request_data = {
      query,
      tag: "diy",
      variables: { registration_number },
    };
    let self = this;
    makeRequestAuth(
      request_data,
      function (response) {
        if (response?.data?.fetchCompanyByTax?.success == 1) {
          this.setState({ fetchAccountDetailsLoader: false });
          const { ipCountryCode } = this.state;
          const { companyDetails: { tax_country_code } = {} } = this.props;
          const companyData = response?.data?.fetchCompanyByTax?.data;
          companyData?.registrationNumber &&
            this.handleInputChange("taxId", {
              target: { value: registration_number },
            });
          companyData?.address &&
            self.handleInputChange("company_address1", {
              target: { value: companyData?.address },
            });

          let companyAddress = this.state.companyAddress;
          companyAddress.state_id = "";
          companyAddress.city_id = "";
          companyAddress.zip_code = "";

          companyData?.country &&
            (() => {
              let selectedCountry = self.props.countryOption.filter(
                (country) =>
                  country?.name?.toLowerCase() ==
                  companyData?.country?.toLowerCase()
              )[0];
              companyAddress.country_id = selectedCountry?.value;
              if (selectedCountry) {
                self.setState({
                  selectedCountry,
                  modified: true,
                  companyAddress,
                });
                this.props.getStateList(selectedCountry.value);
                setTimeout(() => {
                  companyData?.state &&
                    (() => {
                      let selectedState = self.props.stateOption.filter(
                        (state) =>
                          state?.name?.toLowerCase() ==
                          companyData?.state?.toLowerCase()
                      )[0];
                      companyAddress.state_id = selectedState?.value;
                      if (selectedState) {
                        self.setState({
                          selectedState,
                          modified: true,
                          companyAddress,
                        });
                        this.props.getCityList(selectedState.value);
                        setTimeout(() => {
                          companyData?.city &&
                            (() => {
                              let selectedCity = self.props.cityOption.filter(
                                (city) =>
                                  city?.name?.toLowerCase() ==
                                  companyData?.city?.toLowerCase()
                              )[0];
                              companyAddress.city_id = selectedCity?.value;
                              if (selectedCity) {
                                self.setState({
                                  selectedCity,
                                  modified: true,
                                  companyAddress,
                                });
                              }
                            })();
                        }, 1000);
                      }
                    })();
                }, 500);
              }
            })();

          companyData?.state &&
            this.handleInputChange("state", {
              target: { value: companyData?.state },
            });
          companyData?.state &&
            this.handleInputChange("state", {
              target: { value: companyData?.city },
            });
          companyData?.state &&
            this.handleInputChange("zipcode", {
              target: { value: companyData?.postalCode },
            });
          this.setState({ fetchAccountDetailsLoader: false });
        } else {
          this.setState({ fetchAccountDetailsLoader: false });
        }
      }.bind(this)
    );
  };

  debouncedGetCompanySearchList = debounce(this.getCompanySearchList, 500);

  validateTaxtype = () => {
    const { taxType, countryOption } = this.state;
    if (taxType === "" && countryOption.length > 0) {
      this.getTaxDetails();
    }
  };

  getGSTList = () => {
    this.setState({ loading: true });
    let data;
    ProfileService.GSTList()
      .then((response) => {
        if (
          response &&
          response.fetchClientGstDetails &&
          response.fetchClientGstDetails.response &&
          response.fetchClientGstDetails.response.success
        ) {
          data = response.fetchClientGstDetails.response.taxIds;
          this.setState(
            {
              taxIdList: data,
            },
            () => {
              this.taxList();
            }
          );
        }
      })
      .then(() => {
        this.setState({ loading: false });
      });
  };

  getTaxDetails = () => {
    const { companyDetails: { company_country_id } = {} } = this.props;
    const taxType = getTaxType(
      company_country_id,
      this.state.taxIdList,
      this.state.countryOption
    );
    this.setState({ taxType: taxType ? taxType : "" });
  };

  submitEditDetails = () => {
    const { phnNumber = "", phonecode = "" } = this.props;
    this.setState({
      submit_kyb: true,
      showKycConfirmModal: false,
    });
    let {
      companyAddress,
      errorCompanyAddress,
      employeeName,
      phoneNumber,
      isd_code_object,
      selectedCountryISO,
      voucher_distribute_types,
      is_voucher_listed_in_b2c,
      end_user_payment_methods,
      is_voucher_listed_in_crypto,
    } = this.state;

    let errorName = "";
    let errorPhone = "";
    if (companyAddress.companyName.trim() == "") {
      errorCompanyAddress.companyName = "Please provide a valid company name";
    }
    if (companyAddress.company_address1.trim() == "") {
      errorCompanyAddress.company_address1 =
        "Please provide a valid business address";
    }
    if (companyAddress.country_id == "") {
      errorCompanyAddress.country_id = "Please select country";
    }
    if (companyAddress.state_id == "") {
      errorCompanyAddress.state_id = "Please select state";
    }
    if (companyAddress.city_id == "") {
      errorCompanyAddress.city_id = "Please select city";
    }
    if (companyAddress.zip_code == "") {
      errorCompanyAddress.zip_code = "Please enter postal code";
    }
    if (employeeName === "") {
      errorName = "This field cannot be empty.";
      // this.setState({
      //   errorName: "This field cannot be empty."
      // })
    }
    if (phoneNumber && !validatePhoneNo(phoneNumber)) {
      errorPhone = MOBILE_NO_ERROR;
    }
    let errorCountryOfRegistration = "";
    if (!selectedCountryISO?.value) {
      errorCountryOfRegistration = "Please select country of registration";
    }
    this.setState({
      errorCompanyAddress,
      errorName,
      errorPhone,
      errorCountryOfRegistration,
    });

    const isTaxSame = companyAddress.taxId === companyAddress.re_enter_taxId;
    const taxRegex = /^[a-zA-Z0-9\.\-\s]{5,15}$/;
    if (companyAddress.taxId == "") {
      errorCompanyAddress.taxId = "Please enter registered ID";
    }
    if (companyAddress.taxId !== "" && !taxRegex.test(companyAddress.taxId)) {
      errorCompanyAddress.taxId = "Please enter correct registered ID";
    }
    this.setState({ errorCompanyAddress });
    if (
      !Object.keys(errorCompanyAddress).every(
        (ele) => errorCompanyAddress[ele] == ""
      )
    ) {
      this.setState({ submitDisabled: true });
      return;
    }
    this.setState({ showKycConfirmModal: true });
  };

  fetchActivationSteps = () => {
    profileService
      .getActivationSteps()
      .then((response) => {
        if (!response) {
          this.props.update();
          window.location.reload();
        } else {
          this.props.history.push(`/${app_path}/dashboard`);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  modalCloseKyb = () => {
    this.setState({ showKycConfirmModal: false });
  };

  initProfile = () => {
    let {
      companyDetails: {
        company_address1,
        company_city_id,
        company_country_id,
        company_zip_code,
        company_state_id,
        company_tax_id,
        company_website,
      } = {},
      employeeDetails: {
        employee_full_name,
        employee_primary_mobile = "",
      } = {},
    } = this.props;
    // if (!company_country_id || !company_state_id) {
    //   return;
    // }
    let promises = [
      this.getCountryList(),
      company_country_id
        ? this.props.getStateList(parseInt(company_country_id))
        : null,
      company_state_id ? this.getCityList(parseInt(company_state_id)) : null,
    ];
    this.setState({
      loading: true,
    });
    Promise.all(promises)
      .then(() => {
        let {
          selectedCountry,
          selectedState,
          selectedCity,
          countryOption,
          stateOption,
          cityOption,
        } = this.state;
        selectedCountry = countryOption.filter(
          (country) => country.value == company_country_id
        )[0];
        selectedState = stateOption.filter(
          (state) => state.value == company_state_id
        )[0];
        selectedCity = cityOption.filter(
          (city) => city.value == company_city_id
        )[0];
        let companyAddress = {
          city_id: company_city_id,
          company_address1: company_address1,
          country_id: company_country_id,
          state_id: company_state_id,
          zip_code: company_zip_code,
          company_website: company_website,
          taxId: company_tax_id,
          re_enter_taxId: company_tax_id,
          companyName: this.state.companyAddress.companyName,
        };
        this.setState({
          companyAddress,
          loading: false,
          selectedCountry,
          selectedState,
          selectedCity,
        });
        this.validateTaxtype();
        this.getKybAdditionalDetails();
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  taxList = () => {
    const { taxIdList, ipCountryCode } = this.state;
    const { companyDetails: { tax_country_code } = {} } = this.props;
    let selectedCountryISO = {};
    let placeHolder = "";
    let countryTaxIdList = [];

    if (taxIdList && taxIdList.length > 0) {
      let selectedISO = tax_country_code ? tax_country_code : ipCountryCode;
      countryTaxIdList = taxIdList.map((item) => {
        placeHolder = item.placeholder;
        const taxIdType =
          item.type && item.type.split("_").length > 1
            ? item.type.split("_")[1].toUpperCase()
            : "";
        const countrySpecificId =
          item.external_type === "others_tax" ? "" : taxIdType;
        if (item.country === selectedISO) {
          placeHolder = item.placeholder;
          selectedCountryISO = {
            value: item.country,
            label: `${item.country} ${countrySpecificId} ( ${item.description} )`,
            type: `${item.type}` ? `${item.type}` : "GST",
            placeHolder: item.placeholder || "",
            taxType: taxIdType,
          };
        }
        return {
          value: item.country,
          label: `${item.country} ${countrySpecificId} ( ${item.description} )`,
          type: `${item.type}` ? `${item.type}` : "GST",
          placeHolder: item.placeholder || "",
          taxType: taxIdType,
        };
      });
    }
    this.setState(
      {
        countryTaxIdList,
        placeHolder: selectedCountryISO.placeHolder || placeHolder,
        taxType: selectedCountryISO.taxType || "",
      },
      () => this.setState({ selectedCountryISO })
    );
  };

  handleInputChange = (tag, event) => {
    const { companyAddress, errorCompanyAddress } = this.state;
    this.setState({ submitDisabled: false });
    let { employeeDetails: { employee_primary_mobile } = {} } = this.props;
    switch (tag) {
      case "company_website":
        companyAddress.company_website = event.target.value;
        errorCompanyAddress.company_website = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;
      case "linkedIn":
        companyAddress.linkedIn = event.target.value;
        errorCompanyAddress.linkedIn = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;
      case "companyName":
        companyAddress.companyName = event;
        errorCompanyAddress.companyName = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;

      case "taxId":
        const reg = /^[a-zA-Z0-9\.\-\s]{0,50}$/;
        if (!reg.test(event.target.value)) {
          return;
        }
        companyAddress.taxId = event.target.value;
        errorCompanyAddress.taxId = "";
        errorCompanyAddress.re_enter_taxId = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;
      case "re_enter_taxId":
        const reg1 = /^[a-zA-Z0-9\.\-\s]{0,15}$/;
        if (!reg1.test(event.target.value)) {
          return;
        }
        companyAddress.re_enter_taxId = event.target.value;
        errorCompanyAddress.re_enter_taxId = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;
      case "country":
        companyAddress.country_id = event.value;
        errorCompanyAddress.country_id = "";
        companyAddress.state_id = "";
        companyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedCountry: event,
          companyAddress,
          selectedCity: "",
          selectedState: "",
          stateOption: [],
          cityOption: [],
        });
        this.props.getStateList(event.value);
        break;
      case "state":
        companyAddress.state_id = event.value;
        errorCompanyAddress.state_id = "";
        companyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedState: event,
          companyAddress,
          selectedCity: "",
          cityOption: [],
        });
        this.props.getCityList(event.value);
        break;
      case "city":
        companyAddress.city_id = event.value;
        errorCompanyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedCity: event,
          companyAddress,
        });
        break;
      case "zipcode":
        companyAddress.zip_code = event.target.value;
        errorCompanyAddress.zip_code = "";
        this.setState({ modified: true, companyAddress });
        break;
      case "company_address1":
        companyAddress.company_address1 = event.target.value;
        errorCompanyAddress.company_address1 = "";
        this.setState({ modified: true, companyAddress });
        break;
      case "showHideCmpnyBlnce":
        this.setState({ modified: true, switchModified: true });
        this.props.handleShowCompanyBalance();
        break;
      case "phoneNumber":
        const regex = /^\d+$/;
        if (event.target.value.length > 16) {
          return;
        }
        if (
          !(event.target.value.length == 0 && event.target.value == "") &&
          (!regex.test(event.target.value) || parseInt(event.target.value) == 0)
        ) {
          return;
        }
        let changedPhoneNumber = `${this.state.isd_code_object.phonecode}-${event.target.value}`;
        this.setState({
          phoneNumber: event.target.value,
          modified: true,
          errorPhone:
            event.target.value.length > 0 && event.target.value.length < 7
              ? "Phone number should be between 7 to 16 digits."
              : "",
        });
        if (changedPhoneNumber !== employee_primary_mobile) {
          this.setState({
            isMobileVerified: false,
          });
        } else {
          this.setState({
            isMobileVerified: true,
          });
        }
        break;
      case "employeeName":
        this.setState({
          employeeName: event.target.value,
          modified: true,
          errorName: "",
        });
        break;
      case "phoneCode":
        this.setState({ phoneNumber: "", errorPhone: "" });
        changedPhoneNumber = `${event.phonecode}-${this.state.phoneNumber}`;
        this.setState({
          isd_code_object: event,
          modified: true,
        });
        if (changedPhoneNumber !== employee_primary_mobile) {
          this.setState({
            isMobileVerified: false,
          });
        } else {
          this.setState({
            isMobileVerified: true,
          });
        }
        break;
    }
  };

  updateState = (data) => {
    data = {
      ...data,
      modified: true,
    };
    typeof data === "object" ? this.setState(data) : null;
  };

  handleGst = () => {
    const { gstModalShow } = this.state;
    this.setState({ gstModalShow: !gstModalShow });
  };

  setSelectedValue = (selectedOption) => {
    let placeHolder = selectedOption.placeHolder;
    let selectedCountryISO = selectedOption;

    // taxIdList &&
    //   taxIdList.map((item) => {
    //     if (item.country === selectedOption.value) { /* empty */ }
    //   });

    var taxType = "GST";
    if (selectedOption.type) {
      taxType =
        selectedOption.taxType ||
        selectedOption.type.split("_")[1].toUpperCase();
    }
    this.setState({
      selectedCountryISO,
      placeHolder,
      taxType,
      modified: true,
    });
  };

  handleCompanyInputChange = (selectedOption) => {
    this.handleInputChange("companyName", selectedOption.value);
    this.fetchCompanyByTax(selectedOption);
  };

  handleValidation = () => {
    const {
      errorCompanyAddress,
      companyAddress,
      phoneNumber,
      selectedCountryISO,
    } = this.state;
    const taxRegex = /^[a-zA-Z0-9\.\-\s]{5,15}$/;
    let errorName = "";
    let errorPhone = "";
    let errorCountryOfRegistration = "";
    if (companyAddress.companyName.trim() === "") {
      errorCompanyAddress.companyName = "This field cannot be empty.";
      const el = document.getElementById("userEmail");
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    if (!validatePhoneNo(phoneNumber)) {
      errorPhone = MOBILE_NO_ERROR;
    }
    if (!selectedCountryISO?.value) {
      errorCountryOfRegistration = "Please select Country of Registration";
    }
    if (companyAddress.taxId == "") {
      errorCompanyAddress.taxId = "Please enter Registered ID";
    }
    if (companyAddress.taxId !== "" && !taxRegex.test(companyAddress.taxId)) {
      errorCompanyAddress.taxId = "Please enter correct Registered ID";
    }

    let selectError = {
      voucher_distribute_types: "",
      is_voucher_listed_in_b2c: "",
      end_user_payment_methods: "",
      is_voucher_listed_in_crypto: "",
    };

    this.setState({
      errorCompanyAddress,
      errorName,
      errorPhone,
      selectError,
      errorCountryOfRegistration,
    });
    if (
      !Object.keys(errorCompanyAddress).every(
        (ele) => errorCompanyAddress[ele] == ""
      )
    ) {
      return;
    }
    const { accountReducer } = this.props;
    let typeData =
      accountReducer && accountReducer.typeData ? accountReducer.typeData : {};
    if (typeData.role && typeData.role == 100) {
      NotificationManager.error("You Can't Update This", "Error");
      return;
    }
    this.submitKybDetails();
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleModal = () => {
    this.setState({
      showModal: true,
    });
  };

  sendOtpRequestWithToken = (token = "", resend = false) => {
    // this.setState({ showOtpLoading: true });
    const { otpValue, otp_id } = this.state;
    const { phoneNumber, isd_code_object, employeeName } = this.state;
    const payloadData = {
      first_name: employeeName.split(" ")[0]
        ? employeeName.substring(0, employeeName.indexOf(" "))
        : "",
      last_name: employeeName.split(" ")[1]
        ? employeeName.substring(employeeName.indexOf(" ") + 1)
        : "",
      phone: phoneNumber,
      phone_code: isd_code_object.phonecode,
    };
    const options = {
      query: "stores.mutation.update_employee_data",
      tag: "stores",
      variables: {
        update_data: JSON.stringify(payloadData),
      },
    };
    // const isVerificationClicked = this.state.isVerificationClicked;
    const handleValidation = this.handleValidation;
    handleValidation();
    return;
  };

  handleSendOtp = () => {
    const { phoneNumber, isd_code_object, employeeName } = this.state;
    const otpParams = {
      first_name: employeeName.split(" ")[0]
        ? employeeName.substring(0, employeeName.indexOf(" "))
        : "",
      last_name: employeeName.split(" ")[1]
        ? employeeName.substring(employeeName.indexOf(" ") + 1)
        : "",
      phone: phoneNumber,
      phone_code: isd_code_object.phonecode,
    };

    this.setState({
      showOtpLoading: true,
      otpParams,
    });
  };

  fetchAdminDetails = () => {
    const { updateEmployeeDetails } = this.props;

    ProfileService.adminDetails({})
      .then((response) => {
        if (response && response.fetchUserDetails) {
          let userDetails = {
            timeZone: response.fetchUserDetails.timeZone || "",
            employee_first_name: response.fetchUserDetails.first_name || "",
            employee_last_name: response.fetchUserDetails.last_name || "",
            employee_email: response.fetchUserDetails.email || "",
            employee_primary_mobile: response.fetchUserDetails.contact || "",
            platform: response.fetchUserDetails.platform || "",
            domain: response.fetchUserDetails.domain || "",
          };
          userDetails.employee_full_name = userDetails.employee_first_name;
          userDetails.employee_full_name += userDetails.employee_first_name
            ? " " + userDetails.employee_last_name
            : userDetails.employee_last_name;

          updateEmployeeDetails(userDetails);
        }
      })
      .catch(() => {
        //this.setState({ loader: false });
      });
  };

  updateKybStatus = () => {
    this.props.getClientId();
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const selectError = { ...prevState.selectError, [name]: "" };
      return {
        [name]: value,
        selectError: selectError,
        modified: true,
      };
    });
  };

  renderTurnstileCaptcha = (cb) => {
    return (
      <Turnstile
        className="h-100"
        siteKey={TURNSTILE_SITE_KEY}
        onSuccess={(token) => cb(token)}
        options={{ theme: "light" }}
        style={{ width: "100%" }}
      />
    );
  };

  setCurrency = (value) => {
    this.setState({
      companyAddress: {
        city_id: "",
        company_address1: "",
        country_id: "",
        state_id: "",
        zip_code: "",
        company_website: "",
        taxId: "",
        re_enter_taxId: "",
        companyName: "",
        linkedIn: "",
      },
      errorCompanyAddress: {
        city_id: "",
        company_address1: "",
        country_id: "",
        state_id: "",
        zip_code: "",
        company_website: "",
        taxId: "",
        re_enter_taxId: "",
        companyName: "",
        linkedIn: "",
      },
    });
    const currency_value = datas.filter(
      (item) =>
        item.code == (value ? value.currencyValue : this.state.ipCurrencyCode)
    );
    if (currency_value.length > 0) {
      const currencyData = {
        currencyValue: currency_value[0].code,
        country_code: currency_value[0].code,
        label: (
          <Typography component="div" className="d-flex">
            <Typography color="dark" shade="c300" className="m-0">
              {currency_value[0].emoji}{" "}
            </Typography>
            <Typography color="dark" shade="c300" className="m-0 pl-8 pr-4">
              {currency_value[0].name}{" "}
            </Typography>
            <Typography color="dark" shade="c300" className="m-0">
              - {currency_value[0].code}
            </Typography>
          </Typography>
        ),
        currency_id: currency_value[0].currency_id,
        emoji: currency_value[0].emoji,
      };
      this.setState({ currencyValue: currencyData });
    }
  };
  getGeoCountryCode = () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        this.setState(
          {
            ipCountryCode: response?.data?.country_code,
            ipCurrencyCode: response?.data?.currency,
          },
          () => {
            this.getGSTList();
            this.setCurrency();
          }
        );
      })
      .catch(() => {
        this.getGSTList();
      });
  };
  loadOptions = (inputValue, callback) => {
    const abortController = new AbortController();
    this.debouncedGetCompanySearchList(
      inputValue,
      callback,
      abortController.signal
    );
  };

  render() {
    const {
      userBalance: { currencyCode = "INR" } = {},
      platformSetting: { showCompanyBalance = 0 } = {},
      typeData: { role = 100, walletCompany = 0 } = {},
      loader,
    } = this.props;
    const {
      companyAddress,
      loading,
      errorCompanyAddress,
      showKycConfirmModal,
      countryTaxIdList,
      selectedCountryISO,
      showModal,
      phoneNumber,
      showOtpModal,
      invalidOtpMsg,
      showResendMsg,
      otpValue,
      otp_id,
      otpAutoFocusTrigger,
      showOtpLoading,
      isd_code_object,
      invalidOtpCount,
      showVerificationTurnstileCaptcha,
      showResendTurnstileCaptcha,
      errorCountryOfRegistration,
      currencyValue,
    } = this.state;
    let kybStatus = this.props.kybStatus;
    const {
      countryOption,
      cityOption,
      stateOption,
      selectedCountry,
      selectedState,
      selectedCity,
    } = this.props;

    return (
      <>
        {loader ? (
          <Loader />
        ) : (
          <>
            {kybStatus?.kyb_status === 0 ||
            kybStatus?.kyb_status === 3 ||
            kybStatus?.kyb_status === 4 ||
            kybStatus?.kyb_status === 5 ||
            kybStatus?.kyb_status === 6 ? (
              <>
                {/* <Banner description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et doloressdsds sdsdsd scknskcnso elit, sed do eiusmod tempor incididunt ut labore et doloressdsds sdsdsd scknskcnso" /> */}
                <CustomCard spaceAround="6" className="mb-96 mt-24">
                  <div className="d-flex flex-column">
                    <div className="w-100">
                      <Typography component="div" className="d-flex w-100">
                        <Typography component="div" className="w-100">
                          <StyledDropdown
                            value={this.state.currencyValue}
                            options={this.state.currencyCodeList}
                            label="Billing Currency"
                            isSearchable={true}
                            className="mb-28"
                            placeholder={"Select your currency"}
                            onChange={this.setCurrency}
                            helperText={
                              <Typography.HelperText color="dark" shade="c200">
                                This is the currency associated with your
                                account's digital wallet, which is used to store
                                funds for sending rewards to recipients.
                              </Typography.HelperText>
                            }
                          />
                          {currencyValue.currencyValue !== "INR" ? (
                            <EditInfoInput
                              className="w-100 mb-20"
                              label="Registered Business Name"
                              placeholder="Enter your business name Eg: Business Name Pvt. Ltd"
                              value={companyAddress?.companyName || ""}
                              onChange={(e) => {
                                this.handleInputChange(
                                  "companyName",
                                  e.target.value
                                );
                              }}
                              error={errorCompanyAddress.companyName}
                              helperText={
                                errorCompanyAddress.companyName &&
                                errorCompanyAddress.companyName
                              }
                            />
                          ) : (
                            <Dropdown
                              placeholder="Search for your registered business name"
                              className="w-100 mb-20"
                              label="Registered Business Name"
                              value={
                                companyAddress?.companyName
                                  ? {
                                      label: companyAddress.companyName,
                                      value: companyAddress.companyName,
                                    }
                                  : ""
                              }
                              onChange={(e) => {
                                this.handleCompanyInputChange(e);
                              }}
                              error={errorCompanyAddress.companyName}
                              helperText={
                                errorCompanyAddress.companyName &&
                                errorCompanyAddress.companyName
                              }
                              menuPlacement="top"
                              options={this.state.companyList}
                              async={true}
                              loadOptions={this.loadOptions}
                            />
                          )}

                          {this.state.fetchAccountDetailsLoader ? (
                            <div className="w-100">
                              <CircularLoader
                                size="sm"
                                content="Fetching details..."
                              />
                            </div>
                          ) : (
                            companyAddress?.companyName && (
                              <Typography component="div" className="w-100">
                                {currencyValue.currencyValue === "INR" && (
                                  <Banner
                                    iconName=""
                                    color="info"
                                    description={
                                      <Typography.HelperText
                                        color="dark"
                                        shade="c200"
                                      >
                                        These details below are fetched from the
                                        global data billing available publicly.
                                        You can choose to edit them or submit.
                                      </Typography.HelperText>
                                    }
                                    className="py-8 my-24"
                                  />
                                )}
                                <Dropdown
                                  label="Country of Registration"
                                  value={selectedCountryISO}
                                  error={errorCountryOfRegistration}
                                  helperText={
                                    errorCountryOfRegistration && (
                                      <Dropdown.HelperText>
                                        {errorCountryOfRegistration}
                                      </Dropdown.HelperText>
                                    )
                                  }
                                  onChange={this.setSelectedValue}
                                  options={countryTaxIdList}
                                  className="mb-20"
                                />
                                <EditInfoInput
                                  className="mb-20"
                                  label="Business Identification Number"
                                  placeholder="Eg: GST, TAX ID, VAT, EIN, DUNS etc."
                                  value={companyAddress.taxId}
                                  onChange={(e) =>
                                    this.handleInputChange("taxId", e)
                                  }
                                  error={errorCompanyAddress.taxId}
                                  helperText={
                                    errorCompanyAddress.taxId &&
                                    errorCompanyAddress.taxId
                                  }
                                />
                              </Typography>
                            )
                          )}
                        </Typography>
                      </Typography>
                      {companyAddress?.companyName &&
                        !this.state.fetchAccountDetailsLoader && (
                          <>
                            <AddCompanyAddressForm
                              handleInputChange={this.handleInputChange}
                              companyAddress={this.state.companyAddress}
                              countryOption={countryOption}
                              cityOption={cityOption}
                              stateOption={stateOption}
                              selectedCountry={this.state.selectedCountry}
                              selectedState={this.state.selectedState}
                              selectedCity={this.state.selectedCity}
                              loading={loading}
                              errorCompanyAddress={
                                this.state.errorCompanyAddress
                              }
                              isProfileUpdate={true}
                              kybStatus={kybStatus}
                              role={role}
                              addressLoading={this.state.addressLoading}
                              countriesLoading={this.props.countriesLoading}
                              statesLoading={this.props.statesLoading}
                              citiesLoading={this.props.citiesLoading}
                            />
                          </>
                        )}
                    </div>
                  </div>
                </CustomCard>
                <StyledCard className="fixed-bottom">
                  <hr className="m-0" />
                  <div className="px-52 py-20">
                    {kybStatus?.kyb_status === 0 ? (
                      <>
                        <Typography
                          component="div"
                          className="d-flex justify-content-end"
                        >
                          <Button
                            onClick={() => {
                              this.props?.history.goBack();
                            }}
                            disabled={
                              this.state.fetchAccountDetailsLoader ||
                              this.state.loading ||
                              this.state.submitDisabled
                            }
                            className="mr-20"
                            variant="plain"
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={() => {
                              this.submitEditDetails();
                            }}
                            disabled={
                              this.state.fetchAccountDetailsLoader ||
                              this.state.loading ||
                              role === 100 ||
                              companyAddress.companyName === "" ||
                              this.state.submitDisabled
                            }
                            loading={this.state.loading}
                          >
                            Submit Details
                          </Button>
                        </Typography>
                        {showVerificationTurnstileCaptcha ? (
                          <Typography
                            component="div"
                            className="mt-8 d-flex justify-content-end text-right"
                          >
                            {this.renderTurnstileCaptcha(
                              this.sendOtpRequestWithToken
                            )}
                          </Typography>
                        ) : null}
                      </>
                    ) : (
                      <Typography component="div" className="row">
                        <div className="col d-flex justify-content-end">
                          <Button
                            onClick={() => {
                              this.props?.history.goBack();
                            }}
                            disabled={
                              this.state.fetchAccountDetailsLoader ||
                              this.state.loading ||
                              this.state.submitDisabled
                            }
                            className="mr-20"
                            variant="plain"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              this.submitEditDetails();
                            }}
                            loading={loading || loader}
                            disabled={
                              this.state.fetchAccountDetailsLoader ||
                              this.state.loading ||
                              role === 100 ||
                              companyAddress.companyName === "" ||
                              this.state.submitDisabled
                            }
                          >
                            Submit Details
                          </Button>
                        </div>
                      </Typography>
                    )}
                  </div>
                </StyledCard>

                {showOtpModal ? (
                  <KybOtpModal
                    showResendTurnstileCaptcha={showResendTurnstileCaptcha}
                    sendOtpRequestWithToken={(token) =>
                      this.sendOtpRequestWithToken(token, true)
                    }
                    closeModal={() =>
                      this.setState({
                        showOtpModal: false,
                        invalidOtpMsg: false,
                        showResendMsg: false,
                        otp_id: "",
                        otpValue: "",
                      })
                    }
                    updateOtp={(otp) =>
                      this.setState(
                        {
                          otpValue: otp,
                          invalidOtpMsg: false,
                          showResendMsg: false,
                        },
                        () => {
                          if (this.state.otpValue.length === 6) {
                            this.sendOtpRequestWithToken();
                          }
                        }
                      )
                    }
                    otpValue={otpValue}
                    isd_code_object={isd_code_object}
                    validateOtp={() => this.sendOtpRequestWithToken()}
                    resendOtp={() =>
                      this.setState({ showResendTurnstileCaptcha: true }, () =>
                        this.handleSendOtp()
                      )
                    }
                    otp_id={otp_id}
                    phnNumber={phoneNumber}
                    showResendMsg={showResendMsg}
                    invalidOtpMsg={invalidOtpMsg}
                    otpAutoFocusTrigger={otpAutoFocusTrigger}
                    showOtpLoading={showOtpLoading}
                    triggerFocus={(data) =>
                      this.setState({ otpAutoFocusTrigger: data })
                    }
                    invalidOtpCount={invalidOtpCount}
                  />
                ) : null}

                <Modal
                  isOpen={showKycConfirmModal}
                  onClose={() => {
                    this.setState({ showKycConfirmModal: false });
                  }}
                  size="sm"
                >
                  <Typography.H2>Are You Sure?</Typography.H2>
                  <Typography color="dark" shade="c200" className="mt-12">
                    {kybStatus?.kyb_status == 6
                      ? "You are about to submit your business details for account reactivation. Once complete you will be able to resume reward and wallet activities. This usually takes one business hour."
                      : "You are about to submit your business details for verification. Once complete you will have full access to Xoxoday platform. This usually takes one business hour."}
                  </Typography>
                  <div
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <Button
                      color="primary"
                      variant="plain"
                      mr="1"
                      onClick={() => this.modalCloseKyb()}
                    >
                      No, Cancel
                    </Button>
                    <Button
                      color="primary"
                      variant="fill"
                      onClick={() => {
                        this.submitKybDetails();
                      }}
                      loading={this.state.loading}
                      disabled={this.state.loading}
                    >
                      Yes, Submit
                    </Button>
                  </div>
                </Modal>
              </>
            ) : (
              <Typography component="div">
                <div className="d-flex flex-column">
                  <Typography component="div" color="dark" shade="c200">
                    Business Name:
                    <Typography component="span" color="dark" shade="c300">
                      {this.props.accountReducer?.companyDetails?.company_name}
                    </Typography>
                  </Typography>
                  <Typography component="div" color="dark" shade="c200">
                    Country of Registration:
                    <Typography component="span" color="dark" shade="c300">
                      {
                        this.props.accountReducer?.companyDetails
                          ?.tax_country_code
                      }
                    </Typography>
                  </Typography>
                  <Typography component="div" color="dark" shade="c200">
                    Business Identification:
                    <Typography component="span" color="dark" shade="c300">
                      {
                        this.props.accountReducer?.companyDetails
                          ?.company_tax_id
                      }
                    </Typography>
                  </Typography>
                </div>
                {kybStatus?.kyb_status === 2 && walletCompany === 1 && (
                  <CustomCard spaceAround={6} className="mt-24">
                    <Typography
                      component="div"
                      className="d-flex justify-content-between"
                    >
                      <Typography
                        component="div"
                        className="d-flex align-items-center"
                      >
                        <Typography
                          color="dark"
                          shade="c300"
                          className="p-0 m-0"
                        >
                          Admins can view the wallet balance when rewarding.
                        </Typography>
                        <Switch
                          disabled={role === adminRole.admin}
                          active={showCompanyBalance == 1 ? true : false}
                          onClick={(e) => {
                            this.handleInputChange("showHideCmpnyBlnce", e);
                            this.props.update("Account details updated");
                          }}
                          className="ml-4"
                        />
                      </Typography>
                      <Typography component="div">
                        {!(kybStatus?.kyb_status === 2) ? (
                          <Button
                            onClick={() => {
                              if (kybStatus.kyb_status === 2) {
                                this.props.update();
                              } else {
                                this.submitEditDetails();
                              }
                            }}
                            disabled={
                              !this.state.switchModified || loading || loader
                            }
                            loading={loading || loader}
                          >
                            Save
                          </Button>
                        ) : null}
                      </Typography>
                    </Typography>
                  </CustomCard>
                )}

                {showOtpModal ? (
                  <KybOtpModal
                    closeModal={() =>
                      this.setState({
                        showOtpModal: false,
                        invalidOtpMsg: false,
                        showResendMsg: false,
                        otp_id: "",
                        otpValue: "",
                      })
                    }
                    updateOtp={(otp) => {
                      this.setState({
                        otpValue: otp,
                        invalidOtpMsg: false,
                        showResendMsg: false,
                      });
                    }}
                    otpValue={otpValue}
                    isd_code_object={isd_code_object}
                    validateOtp={() => this.handleSendOtp()}
                    resendOtp={() => this.handleSendOtp("resend")}
                    otp_id={otp_id}
                    phnNumber={phoneNumber}
                    showResendMsg={showResendMsg}
                    invalidOtpMsg={invalidOtpMsg}
                    otpAutoFocusTrigger={otpAutoFocusTrigger}
                    showOtpLoading={showOtpLoading}
                    triggerFocus={(data) =>
                      this.setState({ otpAutoFocusTrigger: data })
                    }
                    invalidOtpCount={invalidOtpCount}
                  />
                ) : null}
              </Typography>
            )}
          </>
        )}

        <KYBSubmitInfoModal
          showModal={showModal}
          handleSave={this.closeModal}
          closeModal={this.closeModal}
        />
      </>
    );
  }
}

export default SubmitKybForm;
